export enum ADD_LITING_STEPS {
  BASIC_INFO = 'basicInfo',
  LISTING_DESCRIPTION = 'listingDescription',
  LISTING_DETAILS = 'listingDetails',
  PHOTOS_VIDEOS = 'photosVideos',
  PUPLISH = 'publish',
}

export type StepType = {
  id: number;
  title: string;
  url: string;
};

export type SectionType = {
  id: number;
  title: string;
  slug: string;
};

export enum SectionsEnum {
  FOR_RENT = 'for-rent',
  FOR_SALE = 'for-sale',
}

export type AddListingInitializeType = {
  section: number;
  propertyType: number;
  location: number | null;
  referenceNumber?: string;
  centerLat: number;
  centerLng: number;
};

export type PropertiesType = {
  singularName: string;
  id: number;
  children: PropertiesType[];
};

export type LocationType = {
  id: number;
  slug: string;
  center_lat: number;
  center_lng: number;
  is_active: boolean;
  parent: {
    id: number;
    title: string;
  };
  title: string;
  title_full_path: string;
  eligible_for_mortgage: boolean;
  is_compound_location?: boolean;
  listing?: {
    id: number;
  };
};

export type CloneListingUnitType = {
  id: number;
  title: string | null;
  parent?: {
    id: number;
    parent: null | {
      id: number;
      parent: null;
      area: number | null;
      price: number | null;
    };
    area: number | null;
    price: number | null;
  };
  area?: number | null;
  price?: number | null;
  reference_number?: string | null;
  photos?: ListingPhotosType[];
};

export type AddListingDescriptionFieldKey =
  | 'title-ar'
  | 'title-en'
  | 'description-ar'
  | 'description-en'
  | 'address-ar'
  | 'address-en';

export type AddListingDescriptionFieldType = {
  key: AddListingDescriptionFieldKey;
  errorMessage: string;
};

export type descriptionFieldConfigType = {
  arabic: {
    title: AddListingDescriptionFieldType;
    description: AddListingDescriptionFieldType;
    address: AddListingDescriptionFieldType;
  };
  english: {
    title: AddListingDescriptionFieldType;
    description: AddListingDescriptionFieldType;
    address: AddListingDescriptionFieldType;
  };
};

export type AddListingDescriptionType = {
  'address-ar': string;
  'address-en': string;
  'title-ar': string;
  'title-en': string;
  'description-ar': string;
  'description-en': string;
};

export type ListingPhotosType = {
  id: number;
  photo: {
    thumbnails: { thumb: string; large: string };
  };
  order: number;
};

export type ListingDetailsType = {
  id: number;
  title: string;
  description: string;
  location: LocationType;
  section: SectionType;
  property_type: {
    id: number;
    title: string;
    slug: string;
    amenities: string[];
  };
  center_lat: number;
  center_lng: number;
  photos: ListingPhotosType[];
  price: number | null;
  price_per_meter: number | null;
  area: number | null;
  category: number;
  categoryLabel: string;
  status: number;
  status_label: string;
  is_featured: boolean;
  was_featured: boolean;
  featuredType: {
    type: string | null;
    label: string | null;
  };
  property_view: number;
  property_view_label: string;
  paymentMethodLabel: string;
  seller_role: string;
  is_project_or_unit: boolean;
  isCallRequest: boolean;
  isMortgageApproved: boolean | null;
  deleted_at: string | null;
  updated_at: string;
  accepts_messages: boolean;
  phones: string[];
  listing_phones: string[];
  eligibleForMortgageData: any[];
  video_url: string | null;
  whatsAppNumber: string | null;
  has_parent: boolean;
  address: string;
  attributes: {
    custom_field: { id: number; name: string; label: string };
    value: string;
  }[];
  payment_method: number;
  market_property_type: number;
  propertyRegistrationStatus: number;
  translations: {
    locale: string;
    title: string | null;
    description: string | null;
    address: string | null;
  }[];
  user: {
    id: number;
  };
  amenities?: string[] | null;
  payment_plans?: {
    down_payment: number;
    duration: number;
    price: number;
    over_price: number;
    security_deposit: number;
  }[];
  hasActiveSubscription: boolean;
  publisher_user: {
    id: number;
    name: string;
    email: string;
  };
};

export type FinalizeListingResponseType = {
  message: string;
  listing_id: number;
  listing_status: number;
  fees: null | number;
  duration: null | number;
  available_balance: number;
};

export type CustomFieldsType = {
  id: number;
  name: string;
  label: string;
  options: {
    attr: {
      min: number;
      max: number;
      required: boolean;
      choices: string[];
    };
    choices: { [key: string]: string };
  };
  virtualPropertyTypesIds: number[];
  VirtualPropertyTypes: { [key: string]: string };
  virtualOptions: {
    choices: { id: string; value: number }[];
  };
};

export type addListingDetailsType = {
  area: number;
  price: number;
  propertyView: number;
  paymentMethod: number;
  attributes: {
    customField: number;
    value: number | string;
  }[];
  propertyRegistrationStatus?: number;
  marketPropertyType: number;
  isMortgageApproved?: number;
  isPropertyRegistrationStatusVisible?: boolean;
  amenities?: string[];
  downPaymentType?: 'percentage' | 'amount';
  installmentPeriodType?: 'years' | 'months';
  /* totalInstallmentPrice?: number;
  downPayment?: number;
  installmentPeriod?: number;
  rentalDurations?: { key: string; value: number }[]; */
  rentalDurations?: { key: string; value: number }[];
  paymentPlans?: {
    downPayment?: number;
    duration?: number;
    price: number;
    overPrice?: number;
    securityDeposit?: number;
  }[];
};

export enum ListingStatusEnum {
  DRAFT = 0,
  PENDING = 1,
  LIVE = 2,
  ADMIN_DELETED = 3,
  USER_DELETED = 4,
  EXPIRED = 5,
  PENDING_PHOTOS = 6,
  PENDING_PAYMENT = 7,
  REJECTED = 8,
  SOLD = 9,
  FREEZED = 10,
}

export type InstallmentSummaryStateType = {
  downPayment?: number;
  downPaymentType: 'percentage' | 'amount';
  duration?: number;
  installmentPeriodType: 'years' | 'months';
  overPrice?: number;
  price: number;
  securityDeposit?: number;
};
